
export class ApplicationRightSystemNames {
    static readonly NJORD_PILOT_WEB_LOGIN = "NJORD_PILOT_WEB_LOGIN";
    static readonly ACCESS_TO_BETA_PROGRAM = "ACCESS_TO_BETA_PROGRAM";

    static readonly WEB_MODULE_MY_PILOT_ASSIGNMENTS_WRITE = "WEB_MODULE_MY_PILOT_ASSIGNMENTS_WRITE";
    static readonly WEB_MODULE_CURRENT_PILOTAGES_READ = "WEB_MODULE_CURRENT_PILOTAGES_READ";
    static readonly WEB_MODULE_INCIDENTS_WRITE = "WEB_MODULE_INCIDENTS_WRITE";
    static readonly WEB_MODULE_INCIDENTS_CASEHANDLER_WRITE = "WEB_MODULE_INCIDENTS_CASEHANDLER_WRITE";
    
    
    static readonly WEB_MODULE_PILOT_BOAT_PILOTAGES_READ = "WEB_MODULE_PILOT_BOAT_PILOTAGES_READ";
    static readonly WEB_MODULE_HELICOPTER_PILOTAGES_READ = "WEB_MODULE_HELICOPTER_PILOTAGES_READ";
    static readonly WEB_MODULE_PILOT_TRANSPORT_ORDERS_READ = "WEB_MODULE_PILOT_TRANSPORT_ORDERS_READ";
    static readonly WEB_MODULE_PILOT_ROTATION_WRITE = "WEB_MODULE_PILOT_ROTATION_WRITE";
    static readonly WEB_MODULE_SHIP_OBSERVATION_WRITE = "WEB_MODULE_SHIP_OBSERVATION_WRITE";
    
    
}
